import { Music, Volume2, VolumeX } from 'lucide-react'
import { useGameStore } from '../../store/gameStore'

function MusicOffIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="18" cy="16" r="3" />
      <line x1="2" y1="2" x2="22" y2="22" />
    </svg>
  )
}

export function MenuAudioToggles() {
  const { soundEnabled, musicEnabled, setSoundEnabled, setMusicEnabled } = useGameStore()

  return (
    <div className="menu-audio-toggles">
      <button
        type="button"
        className={`menu-audio-toggle${soundEnabled ? '' : ' is-muted'}`}
        onClick={() => setSoundEnabled(!soundEnabled)}
        aria-label={soundEnabled ? 'Mute sounds' : 'Enable sounds'}
        title={soundEnabled ? 'Mute sounds' : 'Enable sounds'}
      >
        {soundEnabled ? <Volume2 size={20} /> : <VolumeX size={20} />}
      </button>
      <button
        type="button"
        className={`menu-audio-toggle${musicEnabled ? '' : ' is-muted'}`}
        onClick={() => setMusicEnabled(!musicEnabled)}
        aria-label={musicEnabled ? 'Mute music' : 'Enable music'}
        title={musicEnabled ? 'Mute music' : 'Enable music'}
      >
        {musicEnabled ? <Music size={20} /> : <MusicOffIcon size={20} />}
      </button>
    </div>
  )
}

export function GameMenuAudioSliders({ title }: { title?: string } = {}) {
  const {
    soundEnabled,
    musicEnabled,
    soundVolume,
    musicVolume,
    setSoundEnabled,
    setMusicEnabled,
    setSoundVolume,
    setMusicVolume,
  } = useGameStore()

  const displaySound = soundEnabled ? Math.round(soundVolume * 100) : 0
  const displayMusic = musicEnabled ? Math.round(musicVolume * 100) : 0

  function handleSoundChange(raw: number) {
    if (raw === 0) {
      setSoundEnabled(false)
    } else {
      if (!soundEnabled) setSoundEnabled(true)
      setSoundVolume(raw / 100)
    }
  }

  function handleMusicChange(raw: number) {
    if (raw === 0) {
      setMusicEnabled(false)
    } else {
      if (!musicEnabled) setMusicEnabled(true)
      setMusicVolume(raw / 100)
    }
  }

  return (
    <div className="game-menu-audio-controls">
      {title ? <div className="game-menu-section-title">{title}</div> : null}
      <div className="game-menu-audio-row">
        <button
          type="button"
          className={`game-menu-audio-icon-btn${soundEnabled ? '' : ' is-muted'}`}
          onClick={() => setSoundEnabled(!soundEnabled)}
          aria-label={soundEnabled ? 'Mute sounds' : 'Enable sounds'}
        >
          {soundEnabled ? <Volume2 size={20} /> : <VolumeX size={20} />}
        </button>
        <input
          type="range"
          min="0"
          max="100"
          value={displaySound}
          onChange={(e) => handleSoundChange(Number(e.target.value))}
          className="game-menu-audio-slider"
          aria-label="Sound volume"
        />
      </div>
      <div className="game-menu-audio-row">
        <button
          type="button"
          className={`game-menu-audio-icon-btn${musicEnabled ? '' : ' is-muted'}`}
          onClick={() => setMusicEnabled(!musicEnabled)}
          aria-label={musicEnabled ? 'Mute music' : 'Enable music'}
        >
          {musicEnabled ? <Music size={20} /> : <MusicOffIcon size={20} />}
        </button>
        <input
          type="range"
          min="0"
          max="100"
          value={displayMusic}
          onChange={(e) => handleMusicChange(Number(e.target.value))}
          className="game-menu-audio-slider"
          aria-label="Music volume"
        />
      </div>
    </div>
  )
}
